//This file will import all polyfills used for this site

import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import './StringStartsWith';
import './ArrayFind';
import './classList';


// WEBPACK FOOTER //
// ./src/polyfills/index.js